/**
 * Formats a user's display name based on available fields.
 * Priority: Nickname (userName) > Full Name (name) > Masked Wallet Address > Fallback
 */
export const formatDisplayName = (user: {
    userName?: string;
    name?: string;
    walletAddress?: string;
    id?: string;
    userId?: string;
}) => {
    const { userName, name, walletAddress, id, userId } = user;
    const finalId = id || userId;

    if (userName && !isWalletAddress(userName) && !isUUId(userName)) return userName;
    if (name) return name;

    // If userName is actually a wallet address or ID, try fallback to wallet address
    const addressToMask = walletAddress || (isWalletAddress(userName || '') ? userName : null) || (isWalletAddress(finalId || '') ? finalId : null);

    if (addressToMask) {
        return maskString(addressToMask);
    }

    if (userName && !isUUId(userName)) return userName;

    return '미설정 유저';
};

/**
 * Checks if a string is likely a wallet address (0x...)
 */
export const isWalletAddress = (str: string) => {
    return /^0x[a-fA-F0-9]{40}$/.test(str) || (str.startsWith('0x') && str.length > 20);
};

/**
 * Checks if a string is likely a UUID/Firebase ID
 */
export const isUUId = (str: string) => {
    // Basic check for long alphanumeric strings often used as IDs
    return /^[a-zA-Z0-9-]{20,}$/.test(str);
};

/**
 * Masks a long string (Wallet Address, ID, etc.)
 */
export const maskString = (str: string | undefined, head = 4, tail = 4) => {
    if (!str) return '';
    if (str.length <= head + tail) return str;
    return `${str.slice(0, head)}...${str.slice(-tail)}`;
};
